// Recovered compiled webpack factory 51217. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { NJ: () => i, a3: () => s, m7: () => l });
  var n = r(61571),
    a = r(43275);
  let o = r(49636).O;
  function i() {
    return "history" in o && !!o.history;
  }
  function s(e) {
    return e && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
  }
  function l() {
    if ("string" == typeof EdgeRuntime) return !0;
    if (
      !(function () {
        if (!("fetch" in o)) return !1;
        try {
          return (new Headers(), new Request("data:,"), new Response(), !0);
        } catch {
          return !1;
        }
      })()
    )
      return !1;
    if (s(o.fetch)) return !0;
    let e = !1,
      t = o.document;
    if (t && "function" == typeof t.createElement)
      try {
        let r = t.createElement("iframe");
        ((r.hidden = !0),
          t.head.appendChild(r),
          r.contentWindow?.fetch && (e = s(r.contentWindow.fetch)),
          t.head.removeChild(r));
      } catch (e) {
        n.T &&
          a.Yz.warn(
            "Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ",
            e,
          );
      }
    return e;
  }
}
